import ENV from "config/Env";
import { backendQueryKey } from "hooks";

import type { Kiosk, KioskLabel } from "models";

const component = "KioskDashboard";

export const KioskDashboardQueryKeys = {
  kiosks: backendQueryKey<Kiosk[]>({ component, baseUrl: ENV.kioskBaseURL, endpoint: "/dashboard/list" }),
  labels: backendQueryKey<KioskLabel[]>({ component, baseUrl: ENV.kioskBaseURL, endpoint: "/dashboard/labels/list" })
};
